import React, { FC } from 'react';
import BlockWrapper from '@components/common/BlockWrapper';
import { getMachineCountingMethodLabel } from '@components/settings/v2/structure/machines/machineDetails/helpers';
import { COUNTING_METHOD, Machine } from '@interfaces/machines';
import { scale } from '@components/frame';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';
import { BLOCKS_GAP } from '@components/settings/v2/structure/machines/machines/machineCountSettings/constants';
import ColorWrapper, { WithColor } from '@styles/colors';

interface QuantityBlockProps extends WithColor, Pick<Machine, 'machineQuantityType'> {
  currentCountingMethod: COUNTING_METHOD | null;
  quantityBlockDescription: string;
  shouldDisplayQuantityType: boolean;
}

const QuantityBlock: FC<QuantityBlockProps> = ({
  C,
  quantityBlockDescription,
  currentCountingMethod,
  machineQuantityType,
  shouldDisplayQuantityType,
}) => {
  return (
    <>
      <BlockWrapper
        title={currentCountingMethod ? getMachineCountingMethodLabel(currentCountingMethod).toUpperCase() : ''}
        description={quantityBlockDescription}
        marginBottom={machineQuantityType ? scale(BLOCKS_GAP) : 0}
      />
      {machineQuantityType && shouldDisplayQuantityType && (
        <BlockWrapper>
          <InputLine
            {...{
              borderBottomRadius: true,
              borderTopRadius: true,
              data: [{}],
              onlyLabel: false,
              index: 0,
              i: {
                name: 'Quantity Type',
                value: machineQuantityType,
                isText: true,
              },
              C,
              loading: false,
            }}
          />
        </BlockWrapper>
      )}
    </>
  );
};

export default ColorWrapper(QuantityBlock);
